module.exports = [
	{
		"ags": "01054090",
		"name": "Norderfriedrichskoog",
		"text": "Norderfriedrichskoog ist eine ehemalige Steueroase – als die Steuervergünstigungen durch eine Gesetzesänderungaufgehoben wurde, zogen viele Unternehmen weg, und die Minijob-Quote ging zurück. Doch immer noch gibt es einige Briefkastenfirmen, die von Landwirten gegen einen kleinen Beitrag – auf Minijob-Basis – verwaltet werden."
	},
	{
		"ags": "07131050",
		"name": "Meuspath",
		"text": "Gewerbegebiet, u.a. Motorsport. Meuspath wurde kritisiert, weil das Gewerbegebiet anscheinend nicht rentabel ist"
	},
	{
		"ags": "07131058",
		"name": "Nürburg",
		"text": "176 Menschen wohnen in Nürburg, 431 Minijobber arbeiten dort. Das liegt am Nürburgring. Es gibt viele Hotels, und die Nürburgring GmbH hat einen Pool von 600 Aushilfen, die an der Kasse, am Infostand oder als Hostessen arbeiten."
	},
	{
		"ags": "07132501",
		"name": "Altenkirchen (Westerwald), Stadt",
		"text": "In Altenkirchen beschäftigen drei Arbeitgeber über 1000 Minijobber: 712 machen Post- und Kurierdienste, 200 arbeiten im Gesundheitsbereich, 100 Minijobber sind im Einzelhandel beschäftigt."
	},
	{
		"ags": "07140082",
		"name": "Lautzenhausen",
		"text": "485 Minijobber arbeiten in Lautzenhausen. In der Gemeinde liegt der Flughafen Frankfurt Hahn. Hanna Hammer, Sprecherin des Flughafens, sagt, dass unter anderem die Abfertigung mit ihrem 24-Stunden-Betrieb auf flexible Arbeitskräfte angewiesen ist. Außerdem liegen mehrere Hotels in Flughafen-Nähe."
	},
	{
		"ags": "07141073",
		"name": "Klingelbach",
		"text": "Laut Statistik kommen auf 710 Einwohner 259 geringfügig Beschäftigte am Arbeitsort (also in der Gemeinde). Nach unserer internen Auszählung sind es viel weniger, nämlich knapp 60. Das kann nur daran liegen, dass es ein oder mehrere Unternehmen gibt, das/die hier eine Filiale unterhält/unterhalten. Dann würden die Klingelbacher Minijobber nicht vor Ort, sondern am Hauptsitz des Betriebs gezählt. Mehr können wir von Montabaur aus nicht herausbekommen."
	},
	{
		"ags": "07143279",
		"name": "Nistertal",
		"text": "In Nistertal liefern ein Gebäudereiniger und zwei Firmen im pharmazeutischen Service die Erklärung."
	},
	{
		"ags": "07143032",
		"name": "Höhr-Grenzhausen, Stadt",
		"text": "Laut Arbeitsagentur gibt es in Höhr-Grenzhausen mehrere Hotels und daher eine Konzentration von Mini-Jobbern im Bereich Service und Küche. Außerdem gibt es dort einen Verlag, der bundesweit 900 Amts- und Mitteilungsblätter herausgibt. Ein Teil davon müsse auch ausgetragen werden – diese Tätigkeit ist ein klassischer Minijob."
	},
	{
		"ags": "07235026",
		"name": "Föhren",
		"text": "In Föhren gibt es ein Gewerbegebiet. Laut Arbeitsagentur arbeiten Minijobber dort vor allem als Zeitungszusteller und in der Logistik."
	},
	{
		"ags": "09475181",
		"name": "Töpen",
		"text": "Die Biosupermarkt-Kette dennree, zu der auch Denns gehört, ist das größte Unternehmen in Töpen – auch Bioprodukte müssen frühmorgens in Regale geräumt werden. Dennree/Denns weigert sich auf Anfrage, die genaue Zahl ihrer Minijobber offenzulegen."
	},
	{
		"ags": "12069604",
		"name": "Stahnsdorf",
		"text": "In Stahnsdorf sitzt das Leiharbeits-Unternehmen Impuls One (siehe Text)."
	},
	{
		"ags": "13071137",
		"name": "Sietow",
		"text": "Sietow liegt am Müritz-See. Seit der Wende hat sich der Tourismus dort stark entwickelt. Darum gebe es dort besonders viele Minijobber, sagt die Arbeitsagentur."
	},
	{
		"ags": "13072098",
		"name": "Stäbelow",
		"text": "Stäbelow ist ein Gewerbegebiet mit 140 Betriebsstätten. (Gewerbegebiete haben oft viele Minijobber)"
	},
	{
		"ags": "13073072",
		"name": "Ralswiek",
		"text": "In der Gemeinde Ralswiek auf Rügen liegt die hohe Anzahl von Minijobbern an einer Veranstaltung: den Störtebeker Festspielen. Leute kommen von der ganzen Insel, um dort zu arbeiten, etwa als Statisten. So können sie kostenlos zum Festival gehen."
	},
	{
		"ags": "14625120",
		"name": "Elsterheide",
		"text": "Die fast 1.400 Minijobber in Elsterheide sind vor allem im verarbeitenden Gewerbe und KFZ-Handel beschäftigt."
	},
	{
		"ags": "16077011",
		"name": "Göpfersdorf",
		"text": "Ein Handwerkerbetrieb hat seinen Firmensitz dort. Daher werden über den Standort viele Minijobs abgerechnet, so die Arbeitsagentur"
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/data/hotspots_stories.json
// module id = 51
// module chunks = 0